import React from "react";
import { Grid, Pagination } from "semantic-ui-react";

const PaginationComponent = ({
  activePage,
  boundaryRange,
  siblingRange,
  showEllipsis,
  showFirstAndLastNav,
  showPreviousAndNextNav,
  totalPages,
  handlePaginationChange,
  pointing,
  secondary,
  horizontalPosition,
}) => {
  return (
    <Grid.Column
      style={{
        display: "flex",
        marginTop: "auto",
        justifyContent: `${horizontalPosition && horizontalPosition}`,
        marginLeft: `${horizontalPosition && horizontalPosition === "right" ? "auto" : ""}`,
      }}
    >
      <Grid.Row>
        <Pagination
          activePage={activePage}
          boundaryRange={boundaryRange}
          onPageChange={(e) => handlePaginationChange(e.target.attributes.value.value)}
          color="blue"
          siblingRange={siblingRange}
          totalPages={totalPages}
          ellipsisItem={showEllipsis ? undefined : null}
          firstItem={showFirstAndLastNav ? undefined : null}
          lastItem={showFirstAndLastNav ? undefined : null}
          prevItem={showPreviousAndNextNav ? undefined : null}
          nextItem={showPreviousAndNextNav ? undefined : null}
          pointing={pointing}
          secondary={secondary}
        />
      </Grid.Row>
    </Grid.Column>
  );
};

export default PaginationComponent;
